import { DatePicker, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Chip, FormControl, FormControlLabel, FormGroup, FormHelperText, Switch, Typography, IconButton } from '@mui/material';
import { formatISO, eachDayOfInterval } from 'date-fns';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useEnrollResidentStyles from 'src/components/resident/EnrollmentModal/EnrollResident/styles';
import { events, track } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import BillingDetailsCustomFee from './BillingDetailsCustomFee';
import { CAP } from './Cap';
import { NotesBlock } from './NotesBlock';
import { Utility } from './Utility';
import useBillingDetailsStyles from './styles';
export const BillingDetails = observer(props => {
  var _previouslyEnrolledTo, _previouslyEnrolledTo2, _previouslyEnrolledTo3, _previouslyEnrolledTo4, _store$homeDashboardS;
  const classes = useBillingDetailsStyles();
  const enrollResidentClasses = useEnrollResidentStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const excludedUtilityNames = props.excludedUtilityNames,
    isDataLoad = props.isDataLoad,
    _props$isSubmited = props.isSubmited,
    isSubmited = _props$isSubmited === void 0 ? false : _props$isSubmited,
    previouslyEnrolledToUnit = props.previouslyEnrolledToUnit,
    propertyData = props.propertyData,
    residentEmail = props.residentEmail,
    showResidentPortalAccess = props.showResidentPortalAccess,
    unitAvailableFromDateOnly = props.unitAvailableFromDateOnly;
  const handlebillingStartDateOnly = date => {
    track(events.datePicked('Billing Start'));
    store.enrollResident.changeInUnitValue('billingStartDateOnly', formatISO(date).split('T')[0]);
    store.enrollResident.validateValue('billingStartDateOnly', true);
  };
  const handleResidentPortalAccessDate = date => {
    track(events.datePicked('Portal Access'));
    store.enrollResident.changeInUnitValue('residentialPortalAccessDate', formatISO(date).split('T')[0]);
    store.enrollResident.validateValue('residentialPortalAccessDate', true);
  };
  const residentPortalAccessMinDate = () => {
    const currentDate = moment().toDate();
    const billingStartDateOnly = moment(store.enrollResident.enrollResidentInUnit.billingStartDateOnly).toDate();
    const billingStartDateOnlyDiff = moment(billingStartDateOnly).toDate();
    billingStartDateOnlyDiff.setDate(billingStartDateOnlyDiff.getDate() - 14);
    if (billingStartDateOnlyDiff.valueOf() > currentDate.valueOf()) {
      return billingStartDateOnlyDiff;
    }
    return currentDate;
  };
  const residentPortalAccessMaxDate = () => {
    const currentDate = moment().toDate();
    // TODO: convert to use moment
    const currentDateWithoutTime = new Date(currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getDate());
    const billingStartDateOnly = moment(store.enrollResident.enrollResidentInUnit.billingStartDateOnly).toDate();
    if (billingStartDateOnly.valueOf() > currentDateWithoutTime.valueOf()) {
      const nowAndbillingStartDateOnlyInterval = eachDayOfInterval({
        start: currentDateWithoutTime,
        end: billingStartDateOnly
      });
      if (nowAndbillingStartDateOnlyInterval.length >= 15) return billingStartDateOnly;
    }
    return null;
  };
  const getAddress = () => {
    const customPrimary = store.residencies.customAddresses.filter(i => i.isPrimary);
    if (customPrimary.length) {
      var _customPrimary$0$deta;
      return "".concat(customPrimary[0].details.street, " ").concat(customPrimary[0].details.city, ", ").concat(customPrimary[0].details.state, " ").concat(customPrimary[0].details.zip).concat((_customPrimary$0$deta = customPrimary[0].details) !== null && _customPrimary$0$deta !== void 0 && _customPrimary$0$deta.secondary ? ', ' + customPrimary[0].details.secondary : '');
    }
    return propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress;
  };
  useEffect(() => {
    if (isDataLoad && unitAvailableFromDateOnly) handlebillingStartDateOnly(moment(unitAvailableFromDateOnly).toDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoad]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('enrollment_modal.bill_this_resident')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "p"
  }, "Select utilities you wish to bill your resident for. If you choose to opt a resident OUT of paying for a utility, you are responsible for that unit's portion of any bill."), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('enrollment_modal.if_unit_is_opted_out'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  })), excludedUtilityNames.length ? /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('enrollment_modal.unit_is_exluded_from_billing', {
      utilityName: excludedUtilityNames.join(', ')
    }),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.blocksList
  }, store.enrollResident.enrollResidentInUnit.billingType === 'Bill' && /*#__PURE__*/React.createElement(React.Fragment, null, store.addNewProperty.utilitiesSetupV2.selectedUtilities.map(utility => /*#__PURE__*/React.createElement("div", {
    className: classes.billItem,
    key: utility.utilityId
  }, /*#__PURE__*/React.createElement(Utility, {
    utility: {
      title: utility.name,
      utilityProviderName: utility.utilityProviderName
    },
    utilityId: utility.utilityId
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.billItem,
    key: 'StatementCAP'
  }, /*#__PURE__*/React.createElement(CAP, {
    capName: t('enrollment_modal.statement_cap'),
    capInfoMark: t('enrollment_modal.statement_cap_help_info'),
    capInputLabel: "Statement cap",
    capValue: store.enrollResident.enrollResidentInUnit.statementCap,
    handleChange: value => store.enrollResident.changeInUnitValue('statementCap', value)
  })))), /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('enrollment_modal.billing_start_date'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('unit_modal.billing_start_date_explanation'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "info"
  })))), (previouslyEnrolledToUnit !== undefined || typeof previouslyEnrolledToUnit === 'object' && Object.keys(previouslyEnrolledToUnit).length) && (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 ? void 0 : previouslyEnrolledToUnit.leaseEndDateOnly) && (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 || (_previouslyEnrolledTo = previouslyEnrolledToUnit.accountData) === null || _previouslyEnrolledTo === void 0 ? void 0 : _previouslyEnrolledTo.firstName) && (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 || (_previouslyEnrolledTo2 = previouslyEnrolledToUnit.accountData) === null || _previouslyEnrolledTo2 === void 0 ? void 0 : _previouslyEnrolledTo2.lastName) && /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('enrollment_modal.living_note', {
      date: moment(previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 ? void 0 : previouslyEnrolledToUnit.leaseEndDateOnly).format('MM/DD/YYYY') || '12/11/2023',
      resident: (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 || (_previouslyEnrolledTo3 = previouslyEnrolledToUnit.accountData) === null || _previouslyEnrolledTo3 === void 0 ? void 0 : _previouslyEnrolledTo3.firstName) + ' ' + (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 || (_previouslyEnrolledTo4 = previouslyEnrolledToUnit.accountData) === null || _previouslyEnrolledTo4 === void 0 ? void 0 : _previouslyEnrolledTo4.lastName),
      interpolation: {
        escapeValue: false
      }
    }),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info",
    size: "medium"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('enrollment_modal.billing_start_date_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    error: isSubmited && !store.enrollResident.isValidField('billingStartDateOnly')
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: store.enrollResident.enrollResidentInUnit.billingStartDateOnly ? moment(store.enrollResident.enrollResidentInUnit.billingStartDateOnly).toDate() : unitAvailableFromDateOnly && moment(unitAvailableFromDateOnly).toDate() || null,
    onChange: date => handlebillingStartDateOnly(date),
    format: "MM/dd/yy",
    label: t('general.start_date'),
    error: isSubmited && !store.enrollResident.isValidField('billingStartDateOnly'),
    minDate: unitAvailableFromDateOnly && moment(unitAvailableFromDateOnly).toDate() || (previouslyEnrolledToUnit === null || previouslyEnrolledToUnit === void 0 ? void 0 : previouslyEnrolledToUnit.leaseEndDateOnly) && moment(previouslyEnrolledToUnit.leaseEndDateOnly).add(1, 'day').toDate()
  }), isSubmited && !store.enrollResident.isValidField('billingStartDateOnly') && /*#__PURE__*/React.createElement(FormHelperText, null, t('errors.start_date_is_required'))))), /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock2
  }, /*#__PURE__*/React.createElement(BillingDetailsCustomFee, {
    customFee: store.enrollResident.enrollResidentInUnit.customAdminFee,
    handleChange: value => store.enrollResident.changeInUnitValue('customAdminFee', value),
    label: t('general.edit')
  })), /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock2
  }, /*#__PURE__*/React.createElement(BillingDetailsCustomFee, {
    customFee: store.enrollResident.enrollResidentInUnit.customLateFee,
    handleChange: value => store.enrollResident.changeInUnitValue('customLateFee', value),
    label: t('general.edit'),
    lateFee: true
  })), !store.company.companyFeatureStore.disableSendPaperInvite && /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock
  }, localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('enrollment_modal.resident_portal_access')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('enrollment_modal.resident_portal_access_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('enrollment_modal.you_will_be_charged'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info",
    size: "medium"
  })), showResidentPortalAccess && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.whiteBlock, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('enrollment_modal.email_invite')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flex, " ").concat(classes.xsSection)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('enrollment_modal.email'), ":\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, residentEmail))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.whiteBlock, " ").concat(classes.xsSection)
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: store.enrollResident.enrollResidentInUnit.automaticallySendPaperInvitations,
    onChange: e => {
      if (e.target.checked) {
        track(events.enabled('Paper Invite'));
      } else {
        track(events.disabled('Paper Invite'));
      }
      store.enrollResident.changeInUnitValue('automaticallySendPaperInvitations', e.target.checked);
    },
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, showResidentPortalAccess && residentEmail ? t('enrollment_modal.send_paper_invitation') : t('enrollment_modal.paper_invite'))
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flex, " ").concat(classes.xsSection)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('enrollment_modal.mailing_address'), ":\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, getAddress())), !showResidentPortalAccess && /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('enrollment_modal.date_invite'), ":\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('enrollment_modal.send_right_away_enroll')))), /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, showResidentPortalAccess ? /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    error: isSubmited && !store.enrollResident.isValidField('residentialPortalAccessDate')
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: store.enrollResident.enrollResidentInUnit.residentialPortalAccessDate ? moment(store.enrollResident.enrollResidentInUnit.residentialPortalAccessDate).toDate() : moment().toDate(),
    onChange: date => handleResidentPortalAccessDate(date),
    format: "MM/dd/yy",
    label: t('enrollment_modal.give_access_on'),
    error: isSubmited && !store.enrollResident.isValidField('residentialPortalAccessDate'),
    minDate: residentPortalAccessMinDate(),
    maxDate: residentPortalAccessMaxDate()
  }), isSubmited && !store.enrollResident.isValidField('residentialPortalAccessDate') && /*#__PURE__*/React.createElement(FormHelperText, null, t('errors.give_access_required')))) : null))), /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('enrollment_modal.paper_statements')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('enrollment_modal.paper_statements_desc'))), !(store.company.companyFeatureStore.disablePaperStatementFee || (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.disablePaperStatementFee) && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('enrollment_modal.us_postage'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info",
    size: "medium"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.whiteBlock, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: store.enrollResident.enrollResidentInUnit.automaticallySendPaperStatements,
    onChange: e => {
      if (e.target.checked) track(events.enabled('Paper Statements'));else track(events.disabled('Paper Statements'));
      store.enrollResident.changeInUnitValue('automaticallySendPaperStatements', e.target.checked);
    },
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, t('enrollment_modal.paper_statements'))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('enrollment_modal.mailing_address'), ":\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, getAddress())))), /*#__PURE__*/React.createElement("div", {
    className: enrollResidentClasses.contentBlock
  }, /*#__PURE__*/React.createElement(NotesBlock, null)));
});